import { plantApi } from 'api/plantApi';
import { weatherApi } from 'api/weatherApi';
import { useAppDispatch, useAppSelector } from 'app/hooks';
import { selectPlantItemSidebar } from 'components/Common/Sidebar/sidebarSlice';
import { plantActions, selectPlantInfo } from 'features/Plant/plantSlice';
import { inverterInfo, objectPlantInfo, ResponseData } from 'models';
import moment from 'moment';
import { useEffect, useState } from 'react';
import { FcFlashOn, FcMoneyTransfer } from 'react-icons/fc';
import AreaActivePower from '../../components/AreaActivePower';
import AreaPerformance from '../../components/AreaPerformance';
import style from './PlantHomePage.module.scss';
export interface PlantHomePageProps {}

export default function PlantHomePage(props: PlantHomePageProps) {
  const plantItemSelected = useAppSelector(selectPlantItemSidebar);
  const currentPlant = useAppSelector(selectPlantInfo);
  const dispatch = useAppDispatch();
  const today = moment().format('YYYY-MM-DD');
  const thisMonth = moment().format('YYYY-MM');
  const thisYear = moment().format('YYYY');
  const [arrayHourly, setArrayHourly] = useState<number>();
  const [arrayToday, setArrayToday] = useState<number>();
  const [arrayMonthly, setArrayMonthly] = useState<number>();
  const [total_cum_out_e, setTotal_cum_out_e] = useState<number>();
  const [electricityPrice, setElectricityPrice] = useState<number>();
  const [weatherInfo, setWeatherInfo] = useState<inverterInfo>();
  useEffect(() => {
    console.log(
      'Log: ~ file: PlantHomePage.tsx ~ line 35 ~ PlantHomePage ~ weatherInfo',
      weatherInfo
    );
  }, [weatherInfo]);

  useEffect(() => {
    if (plantItemSelected) {
      (async () => {
        await dispatch(plantActions.fetchPlantInfo({ type: 'plant_id', id: plantItemSelected }));
        const res: inverterInfo = await weatherApi.fetchWeatherStation(plantItemSelected);
        setWeatherInfo(res);
        const response: objectPlantInfo = await plantApi.fetchElectricityPrice({
          type: 'electricity-price',
          id: plantItemSelected,
        });
        setElectricityPrice(response.electricity_price);
        const responseOne: ResponseData[] = await plantApi.fetchInfoPropertiesEnergy({
          type: 'output-energy',
          properties: 'day',
          id: plantItemSelected,
          time: today,
        });
        setArrayHourly(sumArray(responseOne));
        const responseTwo: ResponseData[] = await plantApi.fetchInfoPropertiesEnergy({
          type: 'output-energy',
          id: plantItemSelected,
          time: thisMonth,
          properties: 'month',
        });
        setArrayToday(sumArray(responseTwo));
        const responseThree: ResponseData[] = await plantApi.fetchInfoPropertiesEnergy({
          type: 'output-energy',
          id: plantItemSelected,
          time: thisYear,
          properties: 'year',
        });
        setArrayMonthly(sumArray(responseThree));
        const responseFour: objectPlantInfo = await plantApi.fetchLatestTimeSeries({
          type: 'output-energy/lifetime',
          id: plantItemSelected,
        });
        setTotal_cum_out_e(sumArray(responseFour.total_cum_out_e));
      })();
    }
  }, [plantItemSelected, dispatch]);

  const sumArray = (array: ResponseData[]) => {
    let sum = 0;
    array.forEach((item) => {
      if (item.value !== null) sum += item.value;
    });
    return sum / 1000;
  };

  return (
    <div className={style.root}>
      <div className={style.plant_info}>
        <div className={style.plant_name}>{currentPlant?.label}</div>
        <div className={style.information}>
          <div className={style.detail_info}>Address: {currentPlant?.address}</div>
          <div className={style.detail_info}>Code: {currentPlant?.code}</div>
          <div className={style.detail_info}>
            Installed capacity:{' '}
            {currentPlant?.system_size !== null ? `${currentPlant?.system_size} kWh` : `N/A`}
          </div>
        </div>
      </div>
      <div className={style.content_header_info}>
        <div className={style.header_plant}>
          <div className={style.item_plant_header}>
            <div className={style.image_item_header}>
              <div className={style.image_today}></div>
            </div>
            <div className={style.container_item_header}>
              <div className={style.content_item_header}>
                <div className={style.label_item_header}>Today</div>
                <div className={style.value_item_header} style={{ color: 'rgb(39 78 110)' }}>
                  <FcFlashOn size={20} style={{ marginRight: '10px' }} />
                  {arrayHourly ? `${arrayHourly.toLocaleString()} kWh` : `N/A`}
                </div>
                <div className={style.value_item_header} style={{ color: '#f26464' }}>
                  <FcMoneyTransfer size={15} style={{ marginRight: '15px' }} />
                  {electricityPrice && arrayHourly
                    ? `${(arrayHourly * electricityPrice).toLocaleString()} VND`
                    : `N/A`}
                </div>
              </div>
            </div>
          </div>
          <div className={style.item_plant_header}>
            <div className={style.image_item_header}>
              <div className={style.image_month}></div>
            </div>
            <div className={style.container_item_header}>
              <div className={style.content_item_header}>
                <div className={style.label_item_header}>This month</div>
                <div className={style.value_item_header} style={{ color: 'rgb(39 78 110)' }}>
                  <FcFlashOn size={20} style={{ marginRight: '10px' }} />
                  {arrayToday ? `${arrayToday.toLocaleString()} kWh` : `N/A`}
                </div>
                <div className={style.value_item_header} style={{ color: '#f26464' }}>
                  <FcMoneyTransfer size={15} style={{ marginRight: '15px' }} />
                  {electricityPrice && arrayToday
                    ? `${(arrayToday * electricityPrice).toLocaleString()} VND`
                    : `N/A`}
                </div>
              </div>
            </div>
          </div>
          <div className={style.item_plant_header}>
            <div className={style.image_item_header}>
              <div className={style.image_year}></div>
            </div>
            <div className={style.container_item_header}>
              <div className={style.content_item_header}>
                <div className={style.label_item_header}>This year</div>
                <div className={style.value_item_header} style={{ color: 'rgb(39 78 110)' }}>
                  <FcFlashOn size={20} style={{ marginRight: '10px' }} />
                  {arrayMonthly ? `${arrayMonthly.toLocaleString()} kWh` : `N/A`}
                </div>
                <div className={style.value_item_header} style={{ color: '#f26464' }}>
                  <FcMoneyTransfer size={15} style={{ marginRight: '15px' }} />
                  {electricityPrice && arrayMonthly
                    ? `${(arrayMonthly * electricityPrice).toLocaleString()} VND`
                    : `N/A`}
                </div>
              </div>
            </div>
          </div>
          <div className={style.item_plant_header}>
            <div className={style.image_item_header}>
              <div className={style.image_lifetime}></div>
            </div>
            <div className={style.container_item_header}>
              <div className={style.content_item_header}>
                <div className={style.label_item_header}>Life time</div>
                <div className={style.value_item_header} style={{ color: 'rgb(39 78 110)' }}>
                  <FcFlashOn size={20} style={{ marginRight: '10px' }} />
                  {total_cum_out_e ? `${total_cum_out_e.toLocaleString()} kWh` : `N/A`}
                </div>
                <div className={style.value_item_header} style={{ color: '#f26464' }}>
                  <FcMoneyTransfer size={15} style={{ marginRight: '15px' }} />
                  {electricityPrice && total_cum_out_e
                    ? `${(total_cum_out_e * electricityPrice).toLocaleString()} VND`
                    : `N/A`}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <AreaActivePower total_cum_out_e={total_cum_out_e} weatherInfor={weatherInfo} />
      <AreaPerformance />
    </div>
  );
}
